module.exports = __webpack_public_path__ + "img/icon-calendar.bb7835a8.svg";